export default {
  label: 'Zakončenie riadku',
  placeholder: 'Vybrať zakončenie riadku',
};
